@if (canCreateInvoices) {
  <div
    class="sectionContainer containerMargins paddedContent"
    style="display: flex; align-items: center"
  >
    <div style="margin-right: 20px">
      <div [class]="'iconButton noHover'" [title]="text">
        <app-icon [type]="iconType" [color]="'#ffffff'" />
      </div>
    </div>
    <div style="flex: 1">
      <h1 class="pageHeader">{{ text }}</h1>
      <br />
      {{ locationName }}
    </div>
    <div
      class="section"
      style="
        width: 50%;
        height: 50px;
        padding-left: 20px;
        justify-content: center;
        align-items: center;
        display: flex;
        gap: 20px;
      "
    >
      <button
        style="
          height: 100%;
          width: 100%;
          padding-left: 15px;
          padding-right: 15px;
          font-size: 1.2em;
        "
        (click)="createInvoiceClicked.emit()"
        class="button_secondary button_var_2"
      >
        Create Invoice
      </button>
      <button
        style="
          height: 100%;
          width: 100%;
          padding-left: 15px;
          padding-right: 15px;
          font-size: 1.2em;
        "
        (click)="invoiceSettingsClicked.emit()"
        class="button_secondary button_var_2"
      >
        Invoice Settings
      </button>
    </div>
  </div>
}

@if (!canCreateInvoices) {
  <div
    class="sectionContainer containerMargins paddedContent"
    style="display: flex; align-items: center"
  >
    <div
      style="
        display: flex;
        align-items: center;
        padding-right: 20px;
        border-right: 1px solid var(--colorOutline);
      "
    >
      <div style="margin-right: 20px">
        <div [class]="'iconButton noHover'" [title]="text">
          <app-icon [type]="iconType" [color]="'#ffffff'" />
        </div>
      </div>
      <div style="flex: 1">
        <h1 class="pageHeader">{{ text }}</h1>
        <br />
        {{ locationName }}
      </div>
    </div>
    <div
      class="section"
      style="
        display: flex;
        gap: 20px;
        height: 30px;
        padding-left: 20px;
        padding-top: 5px;
        justify-content: center;
        align-items: center;
      "
    >
      @if (invoice && invoice.number) {
        <h1 class="pageHeader">Invoice #{{ invoice.number }}</h1>
      }
      <div
        [hidden]="!canEditInvoices || invoice?.status == 'sent' || invoice?.status == 'paid'"
        style="margin-bottom: 5px"
        [class]="'iconButton'"
        [title]="'Edit Invoice'"
        (click)="editInvoiceClicked.emit()"
      >
        <app-icon [type]="IconType.Edit" [color]="'#ffffff'" />
      </div>
    </div>
  </div>
}
